import React, { ReactNode } from "react";
import ToastCheckCircle from "assets/icons/loyalty/toast_check_circle.svg?react";
import ToastDanger from "assets/icons/loyalty/toast_danger.svg?react";
import { VariantToastLoyalty } from "./types";

export const ICONS_TOASTS: Record<VariantToastLoyalty, () => ReactNode> = {
  green: () => <ToastCheckCircle fill="#52C41A" />,
  purple: () => <ToastCheckCircle fill="#722ED1" />,
  yellow: () => <ToastDanger fill="#FDB43C" />,
  red: () => <ToastDanger fill="#F5222D" />,
  blue: () => <ToastCheckCircle fill="#2F54EB" />,
};
